import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const NearbyFoodIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "NearbyFoodIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.33269 4.5603C4.94006 4.5603 4.62179 4.87858 4.62179 5.27116C4.62179 5.6638 4.94007 5.98206 5.33269 5.98206L6.39077 5.98204H10.0257C11.827 5.98204 13.3799 7.04483 14.0918 8.57754H15.3503C15.9818 8.57754 16.5508 8.8454 16.9497 9.27371C17.3488 8.84535 17.9178 8.57746 18.5493 8.57746H20.565V10.5465C20.565 10.9125 20.475 11.2574 20.316 11.5604H21.9994V12.8124C21.9994 17.1199 18.5075 20.6118 14.2001 20.6118H9.79889C5.49142 20.6118 1.99951 17.1199 1.99951 12.8124V11.5604H4.49212C4.69155 10.4202 5.46335 9.47674 6.50048 9.03717C6.06794 8.55499 5.80484 7.9177 5.80484 7.21895V7.15392L5.3327 7.15393C4.2929 7.15393 3.44992 6.31103 3.44992 5.27116C3.44992 4.23132 4.2929 3.38843 5.33269 3.38843H9.47398V4.5603H5.33269ZM8.52875 8.77098H8.6691C8.74266 8.77098 8.81566 8.77334 8.88805 8.77797V7.15391H6.97672V7.21895C6.97672 8.07612 7.6716 8.77098 8.52875 8.77098ZM10.0599 7.15409V9.06998C11.0592 9.52255 11.7988 10.4478 11.9934 11.5604H13.3346V10.4628C13.3346 8.64674 11.8716 7.17242 10.0599 7.15409ZM17.5356 11.56L18.3797 11.5599C18.9394 11.5599 19.3931 11.1062 19.3931 10.5465V9.74934H18.5493C17.9895 9.74934 17.5356 10.2032 17.5356 10.7628V11.56ZM16.3638 10.7628V11.56H15.5199C14.9602 11.56 14.5065 11.1063 14.5065 10.5466V9.74941H15.3503C15.91 9.74941 16.3638 10.2031 16.3638 10.7628ZM10.7935 11.5604C10.5371 10.6279 9.68309 9.94286 8.6691 9.94286H7.8164C6.80244 9.94286 5.94845 10.6279 5.69204 11.5604H10.7935ZM3.17139 12.7323V12.8124C3.17139 13.1842 3.202 13.5488 3.26083 13.9039H20.7381C20.7969 13.5488 20.8276 13.1842 20.8276 12.8124V12.7323H3.17139ZM20.431 15.0758H3.56792C4.49285 17.6215 6.93352 19.4399 9.79889 19.4399H14.2001C17.0654 19.4399 19.5061 17.6215 20.431 15.0758Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default NearbyFoodIcon;
